import { render, staticRenderFns } from "./object.vue?vue&type=template&id=54eb4ab2&scoped=true&"
import script from "./object.vue?vue&type=script&lang=js&"
export * from "./object.vue?vue&type=script&lang=js&"
import style0 from "./object.vue?vue&type=style&index=0&id=54eb4ab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb4ab2",
  null
  
)

export default component.exports